module.exports = __webpack_public_path__ + "img/wipe-perspiration.613674f8.gif";